import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { db, auth } from "../../../../../../firebase";
import {
  collection,
  addDoc,
  doc,
  query,
  where,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { Button, Col, Form, Input, Row, Select } from "antd";
import { SelectMoveInTenantInfo } from "../../../../../../store/moveInTenantSlice";
import {
  numberType,
  salutation,
  tenantStatus,
} from "../../../../../../utils/tenants";

import SubHeading from "../../../../../../components/common/SubHeading";
import WarningMessage from "../../../../../../components/common/WarningMessage";

import "./AdditionalTenants.css";
import { async } from "@firebase/util";

function AdditionalTenants({ current, setCurrent }) {
  const [tenants, setTenants] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isWait, setIsWait] = useState(false);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const tenantData = useSelector(SelectMoveInTenantInfo);

  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(db, "companies", companyName, "tenants");
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          console.log(fetchedData);
          const filteredTenants = fetchedData.filter(
            (item) => item.profileInfo.ref_tenant_id == tenantData.tenantId
          );
          console.log("........", tenantData.tenantId);
          setTenants(filteredTenants);
          console.log("........fi", tenants);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
      console.log("useEffect of add");
    }
  }, [toggle, companyName]);

  console.log("Tenants", tenants);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const addAdditionalTenant = () => {
    const formData = form.getFieldsValue();
    try {
      Object.keys(formData).forEach((field) => {
        if (formData[field] === undefined) {
          formData[field] = "";
        }
      });
      const profileInfo = {
        salutation: formData.salutation,
        firstName: formData.firstName,
        middleName: "",
        lastName: formData.lastName,
        company: "",
        companyNameAsDisplay: "",
        ref_tenant_id: tenantData.tenantId,
      };

      const contact = {
        emails: formData.email ? [{ id: 1, email: formData.email }] : [],
        phoneNumbers: formData.phoneNumber
          ? [
              {
                id: 1,
                phoneNumber: formData.phoneNumber,
                type: formData.type,
                details: "",
              },
            ]
          : [],
        addresses: [],
      };

      const tenantStatus = {
        tenantType: formData.tenantType ? formData.tenantType : "",
        moveInDate: "",
        moveOutDate: "",
        noticeDate: "",
      };

      const screening = {
        dateOfBirth: "",
        driverLicense: "",
        state: "",
        ssn: "",
        creditReportDate: "",
        CreditScore: "",
      };

      const emergencyContact = {
        name: "",
        address: "",
        phoneNumber: "",
        emailAddress: "",
        relationship: "",
      };

      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const tenantRef = collection(companyDocRef, "tenants");

      try {
        addDoc(tenantRef, {
          profileInfo,
          contact,
          tenantStatus,
          screening,
          emergencyContact,
        });
        console.log("Tenant created successfully");
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
      setToggle(!toggle);
      form.resetFields();
      console.log("Done");
    } catch (err) {
      console.log("Failed");
    }
  };

  const handleFormSubmit = () => {
    setIsWait(true);
    const formData = form.getFieldsValue();
    try {
      Object.keys(formData).forEach((field) => {
        if (formData[field] === undefined) {
          formData[field] = "";
        }
      });
      const profileInfo = {
        salutation: formData.salutation,
        firstName: formData.firstName,
        middleName: "",
        lastName: formData.lastName,
        company: "",
        companyNameAsDisplay: "",
        ref_tenant_id: tenantData.tenantId,
      };

      const contact = {
        emails: formData.email ? [{ id: 1, email: formData.email }] : [],
        phoneNumbers: formData.phoneNumber
          ? [
              {
                id: 1,
                phoneNumber: formData.phoneNumber,
                type: formData.type,
                details: "",
              },
            ]
          : [],
        addresses: [],
      };

      const tenantStatus = {
        tenantType: formData.tenantType ? formData.tenantType : "",
        moveInDate: "",
        moveOutDate: "",
        noticeDate: "",
      };

      const screening = {
        dateOfBirth: "",
        driverLicense: "",
        state: "",
        ssn: "",
        creditReportDate: "",
        CreditScore: "",
      };

      const emergencyContact = {
        name: "",
        address: "",
        phoneNumber: "",
        emailAddress: "",
        relationship: "",
      };

      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const tenantRef = collection(companyDocRef, "tenants");

      try {
        addDoc(tenantRef, {
          profileInfo,
          contact,
          tenantStatus,
          screening,
          emergencyContact,
        });
        console.log("Tenant created successfully");
      } catch (err) {
        console.error(err);
        alert(err.message);
        setIsWait(false);
      }
      setToggle(!toggle);
      next();
      console.log("Done");
    } catch (err) {
      console.log("Failed");
      setIsWait(false);
    }
  };

  const deleteTenant = async (id) => {
    try {
      const tenantDocRef = doc(db, "companies", companyName, "tenants", id);
      const filteredTenants = tenants.filter((item) => item.id !== id);
      setTenants(filteredTenants);
      await deleteDoc(tenantDocRef);
      console.log("Tenant deleted successfully");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  return (
    <div className="additional-tenants">
      <SubHeading subHeading="Additional Tenants" />
      <Row gutter={[0, 10]}>
        <Col span={24}>
          <WarningMessage message="A screening report is not detected for this tenant." />
        </Col>
        <Col span={24}>
          <p>
            Enter information for the Primary Tenant, then click Continue. To
            add an additional tenant, click the Add Tenant button below.
          </p>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 0]}>
            {tenants.map((item, index) => {
              return (
                <Col className="tenant-name-container" key={index}>
                  <span>
                    {item?.profileInfo?.firstName}
                    {item?.profileInfo?.lastName}
                  </span>
                  <MdClose onClick={() => deleteTenant(item.id)} />
                </Col>
              );
            })}
          </Row>
        </Col>
        <Col span={24}>
          <Form layout="vertical" onFinish={handleFormSubmit} form={form}>
            <Row gutter={[0, 10]}>
              <Col span={24}>
                <p>
                  <strong>Name</strong>
                </p>
                <Row gutter={[6, 0]}>
                  <Col>
                    <Form.Item label="Salutation" name="salutation">
                      <Select
                        options={salutation}
                        placeholder="Select salutation"
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item label="First" name="firstName">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item label="Last" name="lastName">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <p>
                  <strong>Phone Number</strong>
                </p>
                <Row gutter={[6, 0]}>
                  <Col>
                    <Form.Item label="Type" name="type">
                      <Select options={numberType} placeholder="Select type" />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item label="Number" name="phoneNumber">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <p>
                  <strong>Emails</strong>
                </p>
                <Row gutter={[6, 0]}>
                  <Col>
                    <Form.Item name="email" label="Email Address">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <p>
                  <strong>Tenant Status</strong>
                </p>
                <Row gutter={[6, 0]}>
                  <Col>
                    <Form.Item label="type" name="tenantType">
                      <Select
                        options={tenantStatus}
                        placeholder="Select type"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row justify="space-between">
                  <Col>
                    <Row gutter={[8, 0]}>
                      <Col>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => addAdditionalTenant()}
                        >
                          Add Another Tenant
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row gutter={[8, 0]}>
                      <Col>
                        <Button type="primary" htmlType="submit">
                          Continue
                        </Button>
                      </Col>
                      <Col>
                        <Button onClick={() => prev()}>Previous</Button>
                      </Col>
                      <Col>
                        <Button type="link" onClick={() => navigate("/")}>
                          Cancel Move In
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default AdditionalTenants;
